import React from "react";

/* Small reusable field wrapper: label + error + hint.
   Shared by TenantDetailsTab, OperationsTab, and TenantAdminTab. */
const Field = ({ label, required, error, hint, children }) => (
  <div className="at-field">
    <label className="at-field__label">
      {label} {required && <span className="at-field__required">*</span>}
    </label>
    {children}
    {error && <span className="at-field__error">{error}</span>}
    {!error && hint && <span className="at-field__hint">{hint}</span>}
  </div>
);

export default Field;